import { useCallback, useContext, useMemo, FC } from "react";
import { useHotkeys } from "@blueprintjs/core";
import {
  CommandManagerDispatchContext,
  CommandManagerStateContext,
  isTodoCreateModalOpen,
} from "./CommandManager";
import { TodoCreateQuickDialogCombo } from "./TodoCreateQuickDialogConfig";
import { TodoCreateDialog } from "./TodoCreateDialog";
import { transformFilters } from "../app/todo/model/TodoConnectionFilter";
import { defaultFilters } from "../app/todo/components/TodoListDefaultFilters";

export const TodoCreateQuickDialogHost: FC =
  function TodoCreateQuickDialogHost() {
    const state = useContext(CommandManagerStateContext);
    const dispatch = useContext(CommandManagerDispatchContext);

    const close = useCallback(() => {
      dispatch({
        type: "CLOSE_TODO_CREATE",
      });
    }, [dispatch]);

    const hotkeys = useMemo(
      () => [
        {
          combo: TodoCreateQuickDialogCombo,
          global: true,
          preventDefault: true,
          label: "Todo erstellen",
          onKeyDown: () => {
            dispatch({
              type: "OPEN_TODO_CREATE",
              filters: transformFilters(defaultFilters),
            });
          },
        },
      ],
      [dispatch],
    );
    useHotkeys(hotkeys);

    const { open } = state;

    return (
      <TodoCreateDialog
        filters={
          open?.type === "TODO_CREATE"
            ? open.filters
            : transformFilters(defaultFilters)
        }
        isOpen={isTodoCreateModalOpen(state)}
        onClose={close}
      />
    );
  };
